import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useContext, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, DialogContentText, DialogActions, Box, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MainContext } from '../context';
const ErrorLink = styled(Link)(({ theme }) => ({
    textDecoration: 'underline',
    color: theme.palette.primary.main
}));
export const ErrorDialog = props => {
    const { pageSettings } = useContext(MainContext);
    const ErrorHelp = pageSettings?.elements.errorHelp;
    useEffect(() => {
        document.addEventListener('keydown', handleEnter);
        return () => document.removeEventListener('keydown', handleEnter);
    }, []);
    const handleEnter = (event) => {
        if (event.code === 'Enter') {
            props.handleCloseDialog();
        }
    };
    const getContentForCode = () => {
        if (!props.errorCode) {
            return null;
        }
        switch (props.errorCode) {
            case 'publisher-agreement-problem': {
                const email = pageSettings?.publisherAgreement?.email;
                return email ? (_jsxs(_Fragment, { children: ["Please contact", ' ', _jsx(ErrorLink, { href: `mailto:${email}?subject=${encodeURIComponent('Publisher agreement problem')}`, children: email }), ' ', "if this problem persists."] })) : (_jsx(_Fragment, { children: "Please contact the administrators of this registry if this problem persists." }));
            }
            default:
                return null;
        }
    };
    const codeContent = getContentForCode();
    return (_jsxs(Dialog, { open: props.isErrorDialogOpen, onClose: props.handleCloseDialog, children: [_jsx(DialogTitle, { children: props.title ?? 'Error' }), _jsx(DialogContent, { children: _jsxs(DialogContentText, { sx: { color: theme => theme.palette.error.main }, children: [props.errorMessage, codeContent ? _jsx(Box, { mt: 2, children: codeContent }) : null, ErrorHelp ? _jsx(ErrorHelp, { errorCode: props.errorCode, errorMessage: props.errorMessage }) : null] }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: props.handleCloseDialog, children: "Close" }) })] }));
};
//# sourceMappingURL=error-dialog.js.map